<template>
  <div>
    <div class="over-lay" @click="closePopup"></div>
    <div class="popup">
      <Positive-Vote class="positive-vote" />
      <div class="hdr">Activation</div>
      <div v-if="!resendVerification" class="thanks-section">
        <span>You must confirm your account before proceeding.</span>
        <span>Please check your inbox at <b>{{ userEmail }}</b> for the confirmation email.</span>
        <span class="make-sure">Make sure to check your spam/junk folder as well.</span>
      </div>
      <div v-else class="thanks-section">
        <span>We've sent a confirmation link to <b>{{ userEmail }}</b>.</span>
        <span>Please verify to continue. Make sure to check your spam/junk folder as well.</span>
      </div>
      <div class="btn-section d-flex">
        <V-Button
          v-show="!resendVerification"
          :className="'btn-blue'"
          :text="'Resend Confirmation'"
          :loading="loading"
          :callback="resendActivation"
        ></V-Button>
        <V-Button
          v-show="resendVerification"
          :className="'btn-blue'"
          :text="'Close'"
          :loading="loading"
          :callback="closePopup"
        >
        </V-Button>
      </div>
    </div>
  </div>
</template>

<script>
import positiveVoteIcon from '@/assets/icons/svg/positive-vote.svg'
import button from '@/components/Button'
import { post } from '@/assets/util/rest.js'
import {
  ACTIVATION_POPUP_SHOWN,
  RESEND_ACTIVATION_CLICKED
} from '@/assets/util/constants/analytics.js'
import sharedFunctions from '@/assets/util/functions.js'

export default {
  name: 'Activation-Popup',
  props: ['text', 'data'],
  data: function() {
    return {
      resendVerification: false
    }
  },
  components: {
    'V-Button': button,
    'Positive-Vote': positiveVoteIcon
  },
  methods: {
    closePopup() {
      this.$emit('closed', true)
    },
    resendActivation() {
      //to do: resend activation to server
      sharedFunctions.track(RESEND_ACTIVATION_CLICKED, {}, this.$store.state)
      this.loading = true
      post('lp/resendVerificationLink.htm', this.userEmail)
        .then(() => {
          this.loading = false
          this.resendVerification = true
        })
        .catch(() => {
          this.loading = false
        })
    }
  },
  computed: {
    userEmail() {
      return this.$store.state.header.email
    }
  },
  created() {
    sharedFunctions.track(ACTIVATION_POPUP_SHOWN, {}, this.$store.state)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.over-lay {
  background: rgb(0, 0, 0, 0.85);
  position: fixed;
  height: 100%;
  top: 0px;
  width: 100%;
  left: 0;
  z-index: 3;
}
.popup {
  position: fixed;
  width: 82%;
  color: #474542;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 23px 0;
  border-radius: 5px;
  background-color: $white;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 60px;
  .positive-vote {
    width: 60px;
    height: 60px;
    position: absolute;
    top: -35px;
  }
  .hdr {
    font-size: 20px;
    text-align: center;
    font-weight: 500;
    line-height: 0.84;
    color: $primary-color;
  }
  .thanks-section,
  .note-section {
    width: 80%;
    text-align: center;
    line-height: 1.25;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 15px;
    span{
      display: block;
      &:not(:last-child){
        margin-bottom: 5px;
        b {
          color: $primary-color;
          font-weight: 400;
        }
      }
      &.make-sure {
        font-size: 12px;
        color: $grey-color;
      }
    }
  }
  .note-section {
    width: 100%;
    padding: 24px 15%;
    margin-bottom: 17px;
    opacity: 0.85;
    font-size: 14px;
    line-height: 1.53;
    color: $text-dark;
    background-color: #f7f7f7;
    a {
      color: $primary-color;
    }
  }
  .btn-section::v-deep {
    flex-direction: column;
    button {
      width: 160px;
      padding: 10px 0px;
      margin: 5px;
      font-size: 14px;
      border: solid 1px #56a2f9;
      border-radius: 5px;
      background-color: $white;
    }
    button.btn-blue {
      background-color: $primary-color;
      color: $white;
    }
    .cancelBtn {
      color: $primary-color;
    }
  }
}
</style>
